<div class="absolute w-full py-1 px-10 flex justify-between shadow-md bg-white z-auto">
  <div class="flex items-center cursor-pointer">
      <img src="assets/icons/logo-v2.svg" alt="Westhetics" class="h-8 max-w-[200px] object-contain">
    </div>
</div>